<template>
  <v-app style="max-width: 1440px; margin: auto;">
    <v-content>
      <!-- <header-block /> -->
      <hero-block @openDemo="openDemo" />
      <features />
      <example-block />
      <demo-block ref="demoBlock" />
      <aboutus/>
      <research/>
      <contact-us />
      <footer-block @showLegalDialog="openLegalDialog" />
      <legal-block ref="legalBlock" />
    </v-content>
  </v-app>
</template>

<script>

// import Header from './components/Header';
import HeroBlock from './HeroBlock';
import ExampleBlock from './ExampleBlock';
import DemoBlock from './DemoBlock';
import Features from './Features';
import ContactUs from './ContactUs';
import AboutUs from './AboutUs';
import Research from './Research';
import LegalDialog from './LegalDialog';
import Footer from './Footer';


export default {
  name: 'Main',

  components: {
    // 'header-block': Header,
    'features': Features,
    'hero-block': HeroBlock,
    'example-block': ExampleBlock,
    'demo-block': DemoBlock,
    'contact-us': ContactUs,
    'aboutus': AboutUs,
    'research': Research,
    'legal-block': LegalDialog,
    'footer-block': Footer,
  },

  data: () => ({
    //
  }),

  methods: {
    openDemo() {
      this.$refs.demoBlock.buttonClicked();
    },
    openLegalDialog() {
      this.$refs.legalBlock.openDialog();
    }
  }

};
</script>